// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".display-none[data-v-3137b06c]{display:none}.list[data-v-3137b06c]{margin:16px 0}.list__item[data-v-3137b06c]{display:flex;padding:16px 0}.list__item-name[data-v-3137b06c]{color:var(--c-primary-950)}.list__item-amount[data-v-3137b06c]{color:var(--c-grey-400);font-family:var(--font-family--secondary);font-size:var(--font-size--base);font-style:normal;font-weight:400;letter-spacing:-.25px;line-height:1.5;margin-left:auto;margin-right:16px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
